const validateBar = (bar) => {
    if (bar < 20) bar = 20;
    if (bar > 300) bar = 300;
    return bar; 
};

const validateLpm = (lpm) => {
    if (lpm < 10) lpm = 10;
    if (lpm > 100) lpm = 100;
    return lpm;
};

const validateKw = (kW) => {
    if (kW < 1) kW = 1;
    if (kW > 10) kW = 10;
    return kW;
}

export const kwFromBarAndLpm = (bar, lpm) => {
    bar = validateBar(bar);
    lpm = validateLpm(lpm);
    return (bar*lpm)/600;
};

export const barFromKwAndLpmIdeal = (kW, lpm) => {
    lpm = validateLpm(lpm);
    return validateBar((600*kW)/lpm);
}

export const barFromKAndPresetAndLpmLinear = (k, preset, lpm) => {
    lpm = validateLpm(lpm);
    return validateBar((preset + k*(100-lpm)));
}

export const barFromTwoSpringSystem = (k1, preset, k2, pos, lpm) => {
    lpm = validateLpm(lpm);
    if (lpm >= pos) {
        return validateBar((preset + k1*(100-lpm)));
    } else {
        return validateBar((preset + k1*(100-lpm)) + ((k1+k2)*(pos-lpm)));
    }
}